import { A } from "@solidjs/router";
import { For, Show, Suspense } from "solid-js";
import { useProfile } from '~/context/ProfileProvider';
import { updateDB } from "~/_server";
import { useRIASApp } from "~/context/UserProvider";


export const Profile = () => {
	const { refetchUser } = useRIASApp();
	const { profile, updateProfile } = useProfile();

	const getAddressLines = () => {
		const a = profile.latest?.address;
		if ( !a ) return [];

		return [
			a.title,
			[a.addr1, a.addr2].filter( Boolean ).join( ", " ),
			a.town,
			a.county,
			a.postcode
		].filter( x => x && x.trim() !== "" );
	};

	return (
		<div class="space-y-4">
			<p class="mt-1 text-sm/6 text-gray-500">Some of this information may be displayed publicly so please be sure it is accurate. <button type="button" class="border-amber-300 bg-red-500 text-white p-2 " onClick={() => {
				refetchUser();
			}}>reload</button></p>
			<p class="mt-1 text-sm/6 text-gray-500">Scheme membership requires that – once verification is complete – you let us know of any changes to your profile details or membership of external organisations. Please send any changes of details to <a href="rias-regs@rias.org.uk">rias-regs@rias.org.uk</a>.</p>

			<Suspense fallback={<p>Loading your account details...</p>}>
				<dl class="mt-6 divide-y divide-gray-100 border-t border-gray-200 text-sm/6">
					<div class="py-6 sm:flex">
						<dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 text-right">Registered</dt>
						<dd class="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
							<div class="text-gray-900">{new Date( profile.latest?.registered ).toLocaleDateString( "en-GB", { month: "long", day: "numeric", year: "numeric" } )}</div>
						</dd>
					</div>

					<div class="py-6 sm:flex">
						<dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 text-right">Full name</dt>
						<dd class="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
							<div class="text-gray-900">{profile.latest?.name}</div>
						</dd>
					</div>

					<div class="py-6 sm:flex">
						<dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 text-right">Email address</dt>
						<dd class="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
							<div class="text-gray-900">{profile.latest?.email}</div>
						</dd>
					</div>

					<div class="py-6 sm:flex">
						<dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 text-right">Company</dt>
						<dd class="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
							<div class="text-gray-900">
								{getAddressLines().map( line => <>{line}<br /></> )}
							</div>
						</dd>
					</div>

					<Show when={profile.latest?.memberships}>
						<div class="py-6 sm:flex">
							<dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 text-right">Memberships</dt>
							<dd class="mt-1 flex justify-start gap-x-6 sm:mt-0 sm:flex-auto">

								<For each={['arb', 'ciat', 'cibse', 'rias', 'other']}>
									{m => profile.latest?.memberships[m] && <span class="inline-flex items-center text-nowrap rounded-md bg-primary-50 px-2 py-1 text-xs text-primary-800 inset-ring inset-ring-yellow-600/20">{m.toUpperCase()}&nbsp;<span class="font-medium">{profile.latest?.memberships[m]}</span></span>}
								</For>
							</dd>
						</div>
					</Show>

					<div class="py-6 sm:flex">
						<dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 text-right">Compliance Methods Used</dt>
						<dd class="flex justify-start gap-x-6 sm:mt-0 sm:flex-auto flex-wrap -mt-5">
							<For each={profile.latest?.compliance?.method}>
								{m =>
									<span class="inline-flex items-center text-nowrap rounded-md bg-yellow-50 mt-4 px-2 py-1 text-xs font-medium text-yellow-800 inset-ring inset-ring-yellow-600/20">{m}</span>}
							</For>
						</dd>
					</div>

					<div class="py-6 sm:flex">
						<dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 text-right">Software Used</dt>
						<dd class="mt-1 flex justify-start gap-x-6 sm:mt-0 sm:flex-auto  flex-wrap">
							<For each={profile.latest?.compliance?.software}>
								{s =>
									<span class="inline-flex items-center  text-nowrap  rounded-md bg-purple-50 mt-4 px-2 py-1 text-xs font-medium text-purple-800 inset-ring inset-ring-purple-600/20">{s}</span>}
							</For>
						</dd>
					</div>

					<div class="py-6 sm:flex">
						<dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 text-right">Qualifications</dt>
						<dd class="mt-1 flex flex-wrap justify-start gap-x-6 sm:mt-0 sm:flex-auto">
							<input placeholder="Qualifications for display (optional)" type="text" onChange={async e => await updateProfile( 'qualifications', e.target.value )} class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6" name="userQualifications" value={profile.latest?.qualifications} />
							<span class="block mt-1 w-full text-sm text-gray-600">Qualifications entered here will appear on the <A class="text-primary" href="/certifiers" target="_blank">Certifiers page</A> on the public site.</span>
						</dd>
					</div>
				</dl>
			</Suspense>
		</div>
	);
}


